// extracted by mini-css-extract-plugin
export default {"subInfo":"styles_subInfo__h51nA","title":"styles_title__JyCcK","value":"styles_value__cAXYf","addedValue":"styles_addedValue__So0Lq","values":"styles_values__SVK4x"};